import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  profileContainer: {
    padding: "0 80px",
    [theme.breakpoints.down("md")]: {
      padding: "0 20px",
    },
  },
  container: {
    position: "fixed",
    left: 0,
    top: 0,
    background: theme.palette.white,
    padding: 0,
    margin: 0,
    float: "left",
    zIndex: 11,
    width: "100%",
    height: "100%",
  },
  avatarEditor: {
    position: "relative",
    width: "30%",
    margin: "auto",
    top: "80px",
    minWidth: "250px",
    textAlign: "center",
  },
  avatarCanvas: {
    [theme.breakpoints.down("md")]: {
      width: "240px !important",
      height: "240px !important",
    },
  },
  avatarSlider: {
    [theme.breakpoints.down("md")]: {
      "&.rc-slider": {
        width: "85%",
        margin: "0 auto",
      },

      "&.rc-slider .rc-slider-handle": {
        marginLeft: "0 !important",
      },
    },
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& > button": {
      margin: theme.spacing(4),

      [theme.breakpoints.down("md")]: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
        whiteSpace: "nowrap",
      },
    },
  },

  imageContainer: {
    display: "flex",
    justifyContent: "flex-start",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  controlsContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    textAlign: "start",
    paddingLeft: theme.spacing(2),
    alignItems: "flex-start",

    "& h3": {
      [theme.breakpoints.down("md")]: {
        marginTop: theme.spacing(2),
      },
    },

    "& button": {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(1),

      [theme.breakpoints.down("md")]: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(0),
      },
    },

    "& span": {
      display: "inline-block",
      maxWidth: "220px",
    },

    [theme.breakpoints.down("md")]: {
      paddingLeft: 0,
      alignItems: "center",
    },
  },
  avatar: {
    overflow: "hidden",
    borderRadius: "50%",
    border: `1px solid ${theme.palette.gray.medium}`,
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "border-box",

    "& img": {
      display: "inline",
      margin: "0 auto",
      height: "100%",
      width: "100%",
      objectFit: "cover",
    },
  },
}));
